import { lazy } from 'react';
import BaseLayout from '../components/Layout/BaseLayout';

const Error = lazy(() => import('../pages/Error'));
const Welcome = lazy(() => import('../pages/Welcome'));
const Quiz = lazy(() => import('../pages/Quiz'));
const Question = lazy(() => import('../pages/Question'));
const QuizResult = lazy(() => import('../pages/QuizResult'));
const CameraRedirect = lazy(() => import('../pages/CameraRedirect'));
const Camera = lazy(() => import('../pages/Camera'));
const Photo = lazy(() => import('../pages/Photo'));

/**
 * Route setup used for app structure.
 */
const routes = [
  {
    path: '/',
    id: 'root',
    errorElement: <Error />,
    element: <BaseLayout />,
    children: [
      {
        path: '',
        element: <Welcome />,
      },
      {
        path: 'quiz',
        element: <Quiz />,
      },
      {
        path: 'quiz/:questionIndex',
        element: <Question />,
      },
      {
        path: 'quiz-result',
        element: <QuizResult />,
      },
      {
        path: 'camera',
        element: <CameraRedirect />,
      },
      {
        path: 'camera/:elementType',
        element: <Camera />,
      },
      {
        path: 'photo',
        element: <Photo />,
      },
    ],
  },
];

export default routes;
